import moment from 'moment';
//hypo yes -> notAlone -> hashimoto
//hypo no -> notAlone -> hashimoto
//hypo no & hashi no -> test first
export const PrequalificationQuestions = [
  {
    id: 'previouslyDiagnosed',
    type: 'single',
    endpoint: 'medicalHistory',
    countText: "Let's get started",
    onlyFirstTime: true,
    prompt: 'Were you previously diagnosed with hypothyroidism?',
    fakeDelayer: true,
    options: [
      { questionId: '19', value: 'Yes', answer: 'Yes' },
      { questionId: '19', value: 'No', answer: 'No', goToPage: 'hashimoto' },
      {
        questionId: '19',
        value: 'I have abnormal labs I can upload',
        answer: 'Yes',
      },
      // { questionId: '19', value: "I don't know", answer: 'DontKnow' },
    ],
  },
  {
    id: 'notAlone',
    type: 'notAlone',
    hideCountText: true,
    fakeDelayer: true,
  },
  // {
  //   id: 'states',
  //   hideCountText: true,
  //   type: 'statePicker',
  //   endpoint: 'medicalHistory',
  //   onlyFirstTime: true,
  //   prompt: '',
  //   title: 'Where Are You Today?',
  //   subTitle:
  //     'We’ll match you to a local healthcare provider licensed in your state',
  //   fakeDelayer: true,
  // },
  {
    id: 'hashimoto',
    type: 'single',
    endpoint: 'medicalHistory',
    countText: "Let's get started",
    onlyFirstTime: true,
    prompt: 'What about Hashimoto\'s?',
    fakeDelayer: true,
    options: [{ questionId: '281', value: 'Yes', answer: 'Yes' }, { questionId: '281', value: 'No', answer: 'No' }],
    onSubmitHandler: (selectedOptions, getState) => {
      const st = getState();
      if (selectedOptions.answer === 'N'||selectedOptions.answer === 'No') {
        if (st && st.values && st.values.length > 0) {
          const hypo = st.values.find((x) => x.id === 'previouslyDiagnosed');
          if (!!hypo && hypo.values && hypo.values.answer) {
            if (hypo.values.answer === 'N'||hypo.values.answer === 'No') {
              return 'testFirst';
            }
          }
        }
      }

      return null
    },
  },
  {
    id: 'dobSex',
    type: 'dobSex',
    endpoint: 'medicalHistory',
    hideCountText: true,
    onlyFirstTime: true,
    title: 'Treatment Eligibility',
    subTitle: 'Let’s confirm that you are eligible for this service',
    fakeDelayer: true,
    onSubmitHandler: (value) => {
      if (!value || value.length < 1) {
        return 'reset123';
      }

      try {
        const dob = value[0].value['dob'];

        const age = moment().diff(moment(dob, 'YYYY-MM-DD'), 'years');
        if (age < 18) {
          return 'disqualifiedDob';
        }
      } catch (error) {
        return 'reset123';
      }

      return null;
    },
  },
  {
    id: 'eligibleStart',
    hideCountText: true,
    type: 'eligibleStart',
  },
  {
    id: 'testFirst',
    hideCountText: true,
    type: 'testFirst',
  },
  {
    id: 'disqualifiedDob',
    type: 'DisqualifiedDob',
    hideCountText: true,
  },
];
